<script>
import { productsMethods } from '@state/helpers'
let _ = require('lodash')

export default {
  name: 'SerialSearch',
  components: {},
  props: {
    showResults: {
      type: Boolean,
      default: true,
      required: false
    },
    showModalResults: {
      type: Boolean,
      default: true,
      required: false
    },
  },
  data() {
    return {
      tableHeaders: [
        { key: 'reference', label: 'Referencia' },
        { key: 'name', label: 'Nombre' },
        { key: 'extension', label: 'Extensión' },
        { key: 'serial', label: 'Serial' },
        { key: 'lote', label: 'Lote' },
        { key: 'due_date', label: 'Vencimiento' },
        { key: 'warehouse_name', label: 'Bodega' },
        { key: 'ubication_name', label: 'Ubicación' },
      ],
      modalShow: false,
      serial_input: '',
      serial_input_last: '',
      searching: false,
      results: [],
    }
  },
  computed: {},
  mounted() {
    const context = this
    context.$nextTick(() => context.$refs.serial_input.focus())
  },
  methods: {
    ...productsMethods,
    searchProductBySerial() {
      const context = this
      if (context.serial_input.trim() == '') {
        context.$refs['serial_input'].focus()
        return
      }
      if (context.serial_input.length > 20){
        // hoya:
        if(context.serial_input.substr(24,2) === '21' && context.serial_input.length === 34){
          context.serial_input = context.serial_input.substr(26)
        // hanita:
        } else if(context.serial_input.substr(37,2) === '21' && context.serial_input.indexOf("240¡") > 0){
          let parts = context.serial_input.substr(39).split('240¡')
          context.serial_input = parts[0].substr(0, parts[0].length-2) + '+' + parts[1].substr(0, parts[1].length-1) + ' ' + parts[0].substr(-2)
          // datamatrix - negative power (march/2023)
        } else if(context.serial_input.substr(24,2) === '21' && context.serial_input.search(/(10[A-Z].*240[-])/) > 0){
          let parts = context.serial_input.substr(26).split(/(10[A-Z].*240[-])/)
          context.serial_input = parts[0] + '-' + parts[2]
        // datamatrix (jan/2023)
        } else if(context.serial_input.substr(24,2) === '21' && context.serial_input.search(/(10[A-Z].*240[+])/) > 0){
          let parts = context.serial_input.substr(26).split(/(10[A-Z].*240[+])/)
          context.serial_input = parts[0] + '+' + parts[2]
        // other QR codes
        } else {
          context.serial_input = context.serial_input.split(',')[0]
        }
      }
      context.serial_input = context.serial_input.replaceAll('¡','+')
      context.serial_input_last = _.cloneDeep(context.serial_input)

      let params = `?serial=${context.serial_input.trim()}&page=1&page_size=100`
      context.searching = true
      // const promise = context.fetchProducts(params)
      context
        .fetchProducts(params)
        // return promise
        .then((data) => {
          context.searching = false
          if (data.status === 204) {
            context.$generate_toast(context, 'error', `No se encontró producto ${context.serial_input}`)
            context.results = []
            context.serial_input = ''
            context.$refs['serial_input'].focus()
            return
          }
          // if (Boolean(data.length)) {
          //   context.results = []
          //   return
          // }
          context.serial_input = ''
          context.results = data.data.results
          context.$refs['serial_input'].focus()
          if (context.showModalResults)
            context.modalShow = true
        })
        .catch((error) => {
          context.searching = false
          context.serial_input = ''
          // context.$axios_error_noty(error, context)
          console.log(error)
          context.results = []
          context.$refs['serial_input'].focus()
        })
    },
  },
}
</script>
<template>
  <div>
    <!-- <b-button @click="modalShow = !modalShow" variant="outline-info">
      <i class="fas fa-barcode"></i>
      Lector de Barras
    </b-button> -->

    <!-- <b-modal hide-footer size="lg" v-model="modalShow"> -->
    <!-- <label>Serial</label> -->
    <!-- <b-form-group label="Serial" label-cols-xl="2"> -->
    <b-input-group>
      <b-form-input
        v-model="serial_input"
        autofocus
        ref="serial_input"
        @keyup.enter.prevent="searchProductBySerial()"
      ></b-form-input>
      <b-input-group-append>
        <b-button
          variant="outline-info"
          @click="searchProductBySerial()"
        >
          <b-spinner v-if="searching" small></b-spinner>
          <i v-else class="fas fa-search"></i>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <!-- </b-form-group> -->

    <div class="mt-3" v-if="showResults">
      <h5 v-if="searching" small> Buscando </h5>
      <b-spinner v-if="searching" small></b-spinner>
      <h5 v-if="results.length">Resultado</h5>
      <b-table
        v-if="serial_input_last"
        :fields="tableHeaders"
        stacked="md"
        responsive
        small
        striped
        hover
        :items="results"
        show-empty
        :empty-html="
          `No hay resultados para el S/N: <b>${serial_input_last}</b>`
        "
      >
      </b-table>
    </div>
    <b-modal hide-footer size="xl" v-model="modalShow">
      <h5 v-if="searching" small> Buscando </h5>
      <b-spinner v-if="searching" small></b-spinner>
      <h5 v-if="results.length">Resultado</h5>
      <b-table
        v-if="serial_input_last"
        :fields="tableHeaders"
        stacked="md"
        responsive
        small
        striped
        hover
        :items="results"
        show-empty
        :empty-html="
          `No hay resultados para el S/N: <b>${serial_input_last}</b>`
        "
      >
      </b-table>
    </b-modal>
  </div>
</template>
